module.exports = __webpack_public_path__ + "static/media/icn-medal-achievement.8d15b29c.svg";